export default __webpack_public_path__ + "static/2-323b7ecc8029a4728b3a10837f379f3d.png";